module.exports = __webpack_public_path__ + "img/goods.e585eeeb.png";